import { render, staticRenderFns } from "./BaseRadio.vue?vue&type=template&id=1f21d428&"
import script from "./BaseRadio.vue?vue&type=script&lang=ts&"
export * from "./BaseRadio.vue?vue&type=script&lang=ts&"
import style0 from "./BaseRadio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports